import { SpacesRemainingTag } from 'Modules/FerrySchedule/Components/SpacesRemaining/SpacesRemainingTag';
import React from 'react';

import { useIsTrailerSpaceExceeded } from 'Modules/MultiStopWizard/Hooks/useIsTrailerSpaceExceeded';
import { BookingWizardData } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardData/BaseBookingWizardData';
import { VehicleBookingWizardData } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardData/VehicleBookingWizardData';
import Icon from 'Views/Components/_HumanWritten/Icon/Icon';
import { LegOptionContext } from './Contexts/LegOptionContext';

export default function LegOptionTrailerCapacity() {
	const context = React.useContext(LegOptionContext);

	if (!context) {
		console.error('LegOptionContext is missing in LegOptionTrailerCapacity');
		return null;
	}

	const { wizardData, trip } = context;

	if (
		!(
			wizardData.tabSelected === 'vehicle' &&
			(wizardData.innerWizardData as VehicleBookingWizardData)?.trailerCheckboxSelected
		)
	) {
		return null;
	}

	if (trip.vehicleBookingsClosed ?? false) {
		return null;
	}

	return (
		<LegOptionTrailerCapacityInner
			wizardData={wizardData}
			trailerSpaces={trip.trailerSpotsAvailable}
			vehicleBookingsClosed={context.vehicleBookingsClosed}
			showName={context.showCapacityNames}
			explainClosed={context.explainClosedCapacity}
			explainState={context.explainCapacityState}
		/>
	);
}

interface LegOptionTrailerCapacityInnerProps {
	wizardData: BookingWizardData;
	trailerSpaces: number;
	vehicleBookingsClosed: boolean;
	/** Names the capacity beside its icon. See `showCapacityNames` on the leg-option context. */
	showName?: boolean;
	/** Explains `(closed)`. See `explainClosedCapacity` on the leg-option context. */
	explainClosed?: boolean;
	/** Tooltip describes the state, not the name. See `explainCapacityState` on the context. */
	explainState?: boolean;
}

function LegOptionTrailerCapacityInner({
	wizardData,
	trailerSpaces,
	vehicleBookingsClosed,
	showName = false,
	explainClosed = false,
	explainState = false,
}: LegOptionTrailerCapacityInnerProps) {
	const exceedsAvailableTrailerSpace = useIsTrailerSpaceExceeded(trailerSpaces, wizardData);

	return (
		<SpacesRemainingTag
			space={exceedsAvailableTrailerSpace ? 0 : Math.floor(trailerSpaces)}
			capacityName="Trailers"
			icon={<Icon name="rv_hookup" useMaterialIcons />}
			showCapacityRemaining
			showName={showName}
			explainClosed={explainClosed}
			explainState={explainState}
			closed={vehicleBookingsClosed}
			tooltipText={showName ? undefined : 'Trailers'}
		/>
	);
}
